import { client } from '@/libs/openApi'

export const getHotelViewCounter = async (hotelCode: string) => {
	const { data } = await client.GET('/ibe/v3/locationViewCount', {
		params: {
			query: { hotelCode },
		},
	})
	return data
}
